import { useEffect, useState } from 'react';
import type { EvaluationContext } from '../store/types';
import { useFeatureFlagStore } from './FeatureFlagContext';

export function useEvaluationContext(): [EvaluationContext, (ctx: EvaluationContext) => void] {
  const store = useFeatureFlagStore();
  const [context, setLocal] = useState(() => store.getContext());

  useEffect(() => {
    return store.subscribe(() => setLocal(store.getContext()));
  }, [store]);

  const setContext = (ctx: EvaluationContext) => store.setContext(ctx);
  return [context, setContext];
}
